import React, { useState, useEffect } from 'react';
import { CheckboxUI } from '../Interface';
import { useFormikContext } from 'formik';

const UserGroupUserLinks = ({ disabled }) => {
  const { values, setFieldValue } = useFormikContext();

  const updateUserGroupUserLink = (userGroupId, isChecked) => {
    const updatedLinks = values?.userGroupUserLink?.map((link) =>
      link.id === userGroupId ? { ...link, checked: isChecked } : link
    );
    setFieldValue('userGroupUserLink', updatedLinks);
  };

  return (
    <div>
      {values?.userGroupUserLink?.map((groupLink) => (
        <div key={groupLink.id}>
          <CheckboxUI
            sx={{ margin: 0, padding: '0.2rem' }}
            disabled={disabled}
            onChange={(e) => updateUserGroupUserLink(groupLink.id, e.target.checked)}
            checked={groupLink.checked || false}
          />
          {groupLink.name}
        </div>
      ))}
    </div>
  );
};

export default UserGroupUserLinks;
